module.exports = __webpack_public_path__ + "images/花筑般蓝pr04-2.jpg?v=633f8c6f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr04-2.jpg
 ** module id = 50
 ** module chunks = 1 2
 **/